import { Component, Inject, OnInit } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import {
  ENVIRONMENT_CONFIG,
  EnvironmentConfig,
} from '@cigna/chcp/shared/environment-util';
import { WindowService } from '@cigna/shared/angular/core/window-util';

@Component({
  selector: 'cigna-evernorth-login-redirect',
  templateUrl: './login-redirect.component.html',
  styleUrls: ['./login-redirect.component.scss'],
})
export class LoginRedirectComponent implements OnInit {
  constructor(
    private auth: AuthService,
    private windowService: WindowService,
    @Inject(ENVIRONMENT_CONFIG) private envConfig: EnvironmentConfig,
  ) {}

  ngOnInit() {
    this.auth.loginWithRedirect({
      appState: {
        target: this.extractDestinationUrl(),
      },
      authorizationParams: {
        connection: this.envConfig.auth0.connection,
      },
    });
  }

  extractDestinationUrl() {
    const urlParams = new URLSearchParams(
      new URL(this.windowService.location.href).search,
    );

    return urlParams.get('destinationUrl')?.includes('login')
      ? '/dashboard'
      : urlParams.get('destinationUrl')?.replace('/app', '');
  }
}
